import { useState } from "react";
import { useForm } from "react-hook-form";
import {
  useGetCallbackUrl,
  useGetOAuthClient,
  useSaveCallbackUrl,
} from "../../../hooks/queries/useMerchantOpenApiQueries";
import { toastService } from "../../../providers";
import { extractAxiosErrorMessage } from "../../../services/utils/errorUtils";

export const useCallbackUrl = (apiEnabled) => {
  const {
    data: oauthClient,
    refetch: refetchClient,
  } = useGetOAuthClient(apiEnabled);
  const {
    data: callbackUrlData,
    isError: isUrlError,
    isLoading: isLoadingUrl,
    refetch: refetchUrl,
  } = useGetCallbackUrl(apiEnabled);
  const isLoading = isLoadingUrl;
  const isFetchError = apiEnabled && isUrlError;
  const onRetry = () => { refetchClient(); refetchUrl(); };
  const { mutate: saveCallbackUrl, isPending: isSaving } = useSaveCallbackUrl();

  const hasCredentials = !isFetchError && !!oauthClient?.public_id;

  const [modalOpen, setModalOpen] = useState(false);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { url: "" },
    mode: "onTouched",
  });

  const currentUrl = callbackUrlData?.url ?? "";
  const hasCallbackUrl = !!currentUrl;

  const handleOpenModal = () => {
    reset({ url: currentUrl });
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    reset();
  };

  const handleSave = (data) => {
    saveCallbackUrl(
      { url: data.url.trim() },
      {
        onSuccess: () => {
          setModalOpen(false);
          reset();
          toastService.success(
            hasCallbackUrl
              ? "Callback URL updated successfully"
              : "Callback URL saved successfully",
          );
        },
        onError: (error) => {
          toastService.error(
            extractAxiosErrorMessage(error, "Failed to save callback URL"),
          );
        },
      },
    );
  };

  return {
    control,
    currentUrl,
    hasCallbackUrl,
    hasCredentials,
    isLoading,
    isFetchError,
    onRetry,
    isSaving,
    modalOpen,
    onOpenModal: handleOpenModal,
    onModalClose: handleModalClose,
    onSubmit: handleSubmit(handleSave),
  };
};
